export default __webpack_public_path__ + "static/media/token_card_bg.40f5deaf.png";